// extracted by mini-css-extract-plugin
module.exports = {"playerRoot":"VideoPlayer_playerRoot__2JFUX","opacityZero":"VideoPlayer_opacityZero__3so4g","opacityOne":"VideoPlayer_opacityOne__2zPQT"};